export default class subscriberFormPreview {
    constructor() {
        return {
            restrict: 'E',
            scope: {
                subscriberForm: '&'
            },
            template: require('../../../../views/subscriber/subscriberForm/subscriberFormPreview.html'),
            replace: true,
            controller: SubscriberFormPreviewCtrl,
            controllerAs: 'preview'
        }
    }
};

class SubscriberFormPreviewCtrl {
    constructor($scope, $sce, $filter) {
        this._scope = $scope;
        this._sce = $sce;
        this._translator = $filter('translate');
    }

    static idToFieldTypeName(id) {
        var type;

        switch (id) {
            case 1:
                type = 'text';
                break;
            case 2:
                type = 'single';
                break;
            case 3:
                type = 'multiple';
                break;
            case 4:
                type = 'json';
                break;
            case 5:
                type = 'datetime';
                break;
            case 6:
                type = 'date';
                break;
            case 7:
                type = 'time';
                break;
            default:
                type = 'text';
        }

        return type;
    }

    preview() {
        let formString = '<div class="rulemailer-subscriber-form"><form action="#" method="POST">';

        angular.forEach(this._scope.subscriberForm().fields, (element) => {
            let label = '<label>' + element.label + '</label>';
            let type = this.constructor.idToFieldTypeName(element.custom_field_type_id);
            let input = $("<input type='" + type + "' placeholder='"+element.label+"' name='fields[" + element.field_identifier + "]'>");

            if (element.field_type === 'email') {
                input = $('<input type="' + element.field_type + '" placeholder="' + element.label + '" name="' + element.field_identifier + '">');
            }

            if (element.required === true) {
                input.attr('required', true);
            }

            formString += label;
            formString += input[0].outerHTML;
        });

        if (this._scope.subscriberForm().confirmation.text || this._scope.subscriberForm().confirmation.link.url) {
            formString += '<div>';
            formString += '<input type="checkbox" name="confirmation" required>';
            formString += '<span>' + this._scope.subscriberForm().confirmation.text + ' ' + '</span>';

            if (this._scope.subscriberForm().confirmation.link.url) {
                formString += '<a style="cursor: pointer;">' + (this._scope.subscriberForm().confirmation.link.description ? this._scope.subscriberForm().confirmation.link.description : this._scope.subscriberForm().confirmation.link.url) + '</a>';
            }

            formString += '</div>';
        }

        formString += '<button disabled>' + this._translator('GLOBAL:SEND') + '</button>';
        formString += '</form>';
        formString += '</div>';

        return this._sce.trustAsHtml(formString);
    }
}
